module.exports = "/fonts/vendor/tinymce/skins/lightgray/tinymce.eot?06189313e1c7504e1edaa12766c2cfd9";